import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'

/**
 * useReceiptScanEnabled tells the UI whether this tenant scans receipts
 * (F-RPT-N43 — backend env `FEATURE_RECEIPT_SCAN=1`, surfaced as the
 * server-injected `feature_receipt_scan` key on GET /settings). The Scan
 * receipt button and the Receipts inbox render only when this is true. A
 * missing key (old backend) reads as off.
 *
 * Shares the `['settings','all']` cache, so it adds no network call.
 */
export function useReceiptScanEnabled(): { enabled: boolean; whatsapp: boolean } {
  const { data } = useQuery({
    queryKey: ['settings', 'all'],
    queryFn: () => apiClient.getAllSettings(),
    staleTime: Infinity,
  })
  const all = data?.data as Record<string, unknown> | undefined
  return {
    enabled: all?.feature_receipt_scan === true,
    whatsapp: all?.feature_receipt_scan_whatsapp === true,
  }
}
